module.exports = __webpack_public_path__ + "img/indent-explanation.fa21f616.svg";